// `return` is a fixed enum (success | failure) since @vofficer/audit-log 0.1.5 — the backend
// normalizes older free-text rows ("Created", "Failure - causa: ...") to the same two values on
// read and moves the specific part to `resultDetail`. Anything else (a service not yet redeployed)
// is shown raw rather than hidden.
export const resolveResultLabel = (t, log) => {
  const result = log?.return;
  if (result === 'success' || result === 'failure') return t(`audit:page.result.${result}`);
  return result ?? '';
};

// Table/CSV form: "Failure — Já existe empresa com este cnpj".
export const resolveResultWithDetail = (t, log) => {
  const label = resolveResultLabel(t, log);
  return log?.resultDetail ? `${label} — ${log.resultDetail}` : label;
};
